export * from './NavBarDetailsMobile.ui';
